<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2>
          <v-icon class="mr-2">
            mdi-database-arrow-down
          </v-icon>
          マニフェスト集計
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-expansion-panels v-model="panels" accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して実行
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <validation-observer ref="reportManifestConditionValidate">
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4">
                        <validation-provider
                          v-slot="{ errors }"
                          name="マニフェスト区分"
                        >
                          <v-select
                            v-model="searchForms.manifestType"
                            :items="manifestTypes"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="マニフェスト区分"
                            outlined
                            persistent-placeholder
                            rounded
                            clearable
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="4">
                        <validation-provider
                          v-slot="{ errors }"
                          class="requiredMark"
                          rules="required"
                          name="集計条件"
                        >
                          <v-select
                            v-model="searchForms.summaryCondition"
                            :items="summaryConditions"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="集計条件"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="2">
                        <cs-date-picker
                          :date.sync="searchForms.startDate"
                          @dateChangedCallback="startDateChangedCallback"
                        >
                          <template v-slot="{ on, attrs }">
                            <validation-provider
                              v-slot="{ errors }"
                              class="requiredMark"
                              rules="required"
                              name="期間（From）"
                            >
                              <v-text-field
                                v-model="searchForms.startDate"
                                v-bind="attrs"
                                v-on="on"
                                :error-messages="errors"
                                append-icon="mdi-calendar"
                                clearable
                                dense
                                hide-details="auto"
                                label="期間（From）"
                                outlined
                                persistent-hint
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                style="font-size: 80%"
                                @click:clear="() => {searchForms.startDate = null; searchButtonClickEvent();}"
                              />
                            </validation-provider>
                          </template>
                        </cs-date-picker>
                      </v-col>

                      <v-col cols="12" md="2">
                        <cs-date-picker
                          :date.sync="searchForms.endDate"
                          @dateChangedCallback="endDateChangedCallback"
                        >
                          <template v-slot="{ on, attrs }">
                            <validation-provider
                              v-slot="{ errors }"
                              class="requiredMark"
                              rules="required"
                              name="期間（To）"
                            >
                              <v-text-field
                                v-model="searchForms.endDate"
                                v-bind="attrs"
                                v-on="on"
                                :error-messages="errors"
                                append-icon="mdi-calendar"
                                clearable
                                dense
                                hide-details="auto"
                                label="期間（To）"
                                outlined
                                persistent-hint
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                style="font-size: 80%"
                                @click:clear="() => {searchForms.endDate = null; searchButtonClickEvent();}"
                              />
                            </validation-provider>
                          </template>
                        </cs-date-picker>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          class="requiredMark"
                          rules="required"
                          name="集計内容"
                        >
                          <v-select
                            v-model="searchForms.summaryContent"
                            :items="summaryContents"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="集計内容"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                            @change="summaryContentEvent"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          class="requiredMark"
                          :class="{ requiredMark: searchForms.summaryContent != 'manifest_count' }"
                          :rules="{ required: searchForms.summaryContent != 'manifest_count' }"
                          name="集計単位"
                        >
                          <v-select
                            v-model="searchForms.summaryUnit"
                            :items="summaryUnits"
                            :error-messages="errors"
                            :disabled="searchForms.summaryContent==='manifest_count'"
                            dense
                            hide-details="auto"
                            label="集計単位"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row v-if="environment !== 'production'">
                      <v-col cols="3">
                        <v-text-field
                          v-model="searchForms.manifestIds"
                          clearable
                          dense
                          hide-details="auto"
                          label="DXEマニ番号(テスト用です)"
                          outlined
                          persistent-hint
                          persistent-placeholder
                          placeholder="DXEマニ番号をカンマ区切りで入力"
                          hint="例: 1, 2, 3"
                          rounded
                          style="font-size: 80%"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      @click="exportButtonClickEvent"
                    >
                      <v-icon>mdi-file-download-outline</v-icon>
                      &nbsp;実行
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </validation-observer>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <output-files v-if="enableOutputFile" section="manifest" />
    <!-- アップグレード誘導モーダル -->
    <ec-contract-single-plan-guide-dialog
      :enable-dialog="enableEcContractSinglePlanGuideDialog"
      :from-report="true"
      @closeCallback="dialogCloseCallback"
    />
    <!-- /アップグレード誘導モーダル -->
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import DownloadMixin from '../../../../mixins/download-mixin'
import OutputFiles from '../_OutputFiles.vue'
import EcContractSinglePlanGuideDialog from '../../dialogs/_EcContractSinglePlanGuideDialog'

export default {
  name: 'DriverReportsManifests',
  components: {
    OutputFiles,
    EcContractSinglePlanGuideDialog,
  },
  mixins: [
    DownloadMixin,
  ],
  props: {},
  data() {
    return {
      environment: process.env.VUE_APP_ENV,
      panels: 0,
      enableOutputFile: true,
      enableEcContractSinglePlanGuideDialog: false,
      searchForms: {
        manifestType: null,
        summaryCondition: null,
        startDate: null,
        endDate: null,
        summaryUnit: null,
        summaryContent: null,
        manifestIds: null,
      },
      /** マニフェスト区分 */
      manifestTypes: [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)' },
        { value: 'other_form', text: '電子マニフェスト(WEB)' },
        { value: 'paper_form', text: '紙マニフェスト' },
        { value: 'transfer_form', text: '電子マニフェスト(取込)' }
      ],
      /** 集計条件 */
      summaryConditions: [
        { value: 'emission', text: '排出事業者' },
        { value: 'location', text: '排出事業場' },
        { value: 'month', text: '月別' },
        { value: 'route', text: 'ルート' },
        { value: 'disposer', text: '処分業者' },
        { value: 'disposal_method', text: '処分業者:処分方法' },
      ],
      /** 集計単位 */
      summaryUnits: [
        { value: 't', text: 't' },
        { value: 'm3', text: 'm3' },
        { value: 'kg', text: 'kg' },
        { value: 'liter', text: 'リットル' },
      ],
      /** 集計内容 */
      summaryContents: [
        { value: 'manifest_quantity', text: '排出廃棄物量' },
        { value: 'report_transport_quantity', text: '確定数量' },
        { value: 'disposal_report_amount', text: '処分量' },
        { value: 'manifest_count', text: '交付数' },
      ],
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'loginId'
    ]),
    ...mapState('DriverTenantConfiguration', {
      mode: 'mode',
      isEcContractSinglePlan: 'use_ec_contract_single_plan',
    }),
    maximumDate () {
      if (this.searchForms.startDate) {
        return this.$dayjs(this.searchForms.startDate).add(12, 'months').format('YYYY-MM-DD')
      } else {
        return null
      }
    },
    minimumDate () {
      if (this.searchForms.endDate) {
        return this.$dayjs(this.searchForms.endDate).subtract(12, 'months').format('YYYY-MM-DD')
      } else {
        return null
      }
    },
  },
  created() {
    if (this.mode === 'transport') {
      this.summaryConditions = this.summaryConditions.filter(
        (v) => v.value !== "disposer"
      );
    }
  },
  methods: {
    ...mapActions('DriverReportManifest', {
      outputManifests: 'create',
    }),
    /**
    * 実行ボタン クリックイベント
    */
    exportButtonClickEvent () {

      /** 電子契約単体プランの場合、メッセージを出して終わる */
      if (this.isEcContractSinglePlan) {
        this.enableEcContractSinglePlanGuideDialog = true
      } else {
        this.$refs.reportManifestConditionValidate.validate().then((result) => {
          const conditions = this._buildParams()
          if(result) {
            this.outputManifests({ conditions: conditions, output_type: 'csv'}).then((content) => {
              this.enableOutputFile = false;
              this.$nextTick(() => (this.enableOutputFile = true));
            })
          }
        })
      }
    },
    summaryContentEvent () {
      if (this.searchForms.summaryContent === 'manifest_count') {
        this.searchForms.summaryUnit = null
      }
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback () {
      this.enableEcContractSinglePlanGuideDialog = false
    },
    /**
     * 期間（from）変更　コールバック
     */
    startDateChangedCallback (value) {
      this.searchForms.startDate = value;
    },
    /**
     * 期間（to）変更　コールバック
     */
    endDateChangedCallback (value) {
      this.searchForms.endDate = value;
    },
    _buildParams() {
      return {
        manifest_type: this.searchForms.manifestType,
        summary_condition: this.searchForms.summaryCondition,
        start_date: this.searchForms.startDate,
        end_date: this.searchForms.endDate,
        summary_unit: this.searchForms.summaryUnit,
        summary_content: this.searchForms.summaryContent,
        manifest_ids: this.searchForms.manifestIds,
      }
    }
  }

}
</script>

